import { LETTER_TO_KEYPAD_DIGIT } from "@/constants/form.constants";

export const splitParagraphs = (text: string | undefined) => {
  if (!text) return [];
  return text
    .split(/\r?\n\s*\r?\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
};

export const getDigits = (text = "") => {
  return text.replace(/\D/g, "").slice(0, 10);
};

/** Strips formatting and converts vanity letters to dialable digits. */
export function toDialableNumber(raw: string): string {
  let digits = "";
  for (const char of raw) {
    if (char >= "0" && char <= "9") {
      digits += char;
      continue;
    }
    const mapped = LETTER_TO_KEYPAD_DIGIT[char.toUpperCase()];
    if (mapped) digits += mapped;
  }
  return digits;
}

/**
 * Builds a `tel:` href for NANP numbers (10 digits, or 11 with a leading 1).
 * Supports vanity formats such as `(999) 999-REFE`.
 * Returns an empty string when there are fewer than 10 dialable digits.
 */
export function toTelHref(raw?: string | null | undefined): string {
  if (!raw) return "";
  const digits = toDialableNumber(raw);
  if (digits.length < 10) return "";
  if (digits.length === 11 && digits.startsWith("1")) {
    return `tel:+${digits}`;
  }
  if (digits.length === 10) return `tel:+1${digits}`;
  return `tel:+${digits}`;
}
